import { ORGANIZATION_FIELDS_METADATA } from '../config/userUploaderConfig';
import { OrganizationExportDto } from '../api/types/dtos/organization.dto';

export const EXPORT_UUID_ORG_HEADER = 'UUID Organizacion';
export const EXPORT_UUID_OWNER_HEADER = 'UUID Usuario Propietario';

export interface ExportColumn {
  header: string;
  key: string;
}

const OWNER_NAME_KEY = 'ownerName';
const ORGANIZATION_ID_KEY = 'organizationId';
const OWNER_USER_ID_KEY = 'ownerUserId';

export function getExportColumns(): ExportColumn[] {
  const columns: ExportColumn[] = [{ header: EXPORT_UUID_ORG_HEADER, key: ORGANIZATION_ID_KEY }];

  for (const field of ORGANIZATION_FIELDS_METADATA) {
    if (field.hidden) continue;
    if (field.key === OWNER_NAME_KEY) {
      columns.push({ header: EXPORT_UUID_OWNER_HEADER, key: OWNER_USER_ID_KEY });
    }
    columns.push({ header: field.displayName, key: field.key as string });
  }

  return columns;
}

export function formatExportCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (Array.isArray(value)) return value.join(',');
  if (typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>)
      .map(([name, area]) => `${name}:${area}`)
      .join(',');
  }
  return String(value);
}

const escapeCell = (val: string): string => {
  if (val.includes(',') || val.includes('"') || val.includes('\n')) {
    return `"${val.replace(/"/g, '""')}"`;
  }
  return val;
};

export function buildOrgExportCsv(orgs: OrganizationExportDto[]): string {
  const columns = getExportColumns();
  const lines: string[] = [columns.map((col) => escapeCell(col.header)).join(',')];

  for (const org of orgs) {
    const record = org as unknown as Record<string, unknown>;
    const row = columns.map((col) => escapeCell(formatExportCell(record[col.key])));
    lines.push(row.join(','));
  }

  return `${lines.join('\n')}\n`;
}

export function buildOrgExportJson(orgs: OrganizationExportDto[]): string {
  const columns = getExportColumns();
  const ordered = orgs.map((org) => {
    const record = org as unknown as Record<string, unknown>;
    const obj: Record<string, unknown> = {};
    for (const col of columns) {
      obj[col.key] = record[col.key] ?? null;
    }
    return obj;
  });
  return JSON.stringify(ordered, null, 2);
}

export function downloadOrgExport(orgs: OrganizationExportDto[], format: 'csv' | 'json'): void {
  const content = format === 'csv' ? buildOrgExportCsv(orgs) : buildOrgExportJson(orgs);
  const blob = new Blob([content], {
    type: format === 'csv' ? 'text/csv;charset=utf-8;' : 'application/json;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `organizaciones-${new Date().toISOString().slice(0, 10)}.${format}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
